import { Box, Divider, Paper, Skeleton, Stack, useTheme } from "@mui/material"

export const SkeletonPlaceDetailCard = () => {
  const theme = useTheme()
  const { styleOverrides = {} } = theme.components[`PlaceDetailCard`] || {}
  const {
    container,
    primarySection,
    secondarySection,
    innerSection,
    headerContainer,
    avatarContainer,
    detailContainer,
    listInfoContainer,
    listInfoDivider,
    divider,
    descriptionContainer,
    // Tabs
    placeDetailTabContainer,
    qrCodeContainer,
    actionContainer,
  } = styleOverrides

  return (
    <Paper sx={container}>
      <Box sx={primarySection}>
        <Box sx={innerSection}>
          <Box sx={headerContainer}>
            <Box sx={avatarContainer}>
              <Skeleton variant="rounded" width="132px" height="132px" />
            </Box>
            <Box sx={detailContainer}>
              <Skeleton variant="rounded" width="50%" height="42px" />
              <Stack
                sx={listInfoContainer}
                direction="row"
                spacing={2}
                divider={
                  <Divider
                    sx={listInfoDivider}
                    orientation="vertical"
                    flexItem
                  />
                }
              >
                <Skeleton variant="rounded" width="80%" height="28px" />
                <Skeleton variant="rounded" width="80%" height="28px" />
              </Stack>
              <Stack
                sx={listInfoContainer}
                direction="row"
                spacing={2}
                divider={
                  <Divider
                    sx={listInfoDivider}
                    orientation="vertical"
                    flexItem
                  />
                }
              >
                <Skeleton variant="rounded" width="80%" height="28px" />
                <Skeleton variant="rounded" width="80%" height="28px" />
              </Stack>
            </Box>
          </Box>
          <Divider sx={divider} />
          <Box sx={descriptionContainer}>
            <Skeleton variant="rounded" width="500px" height="60px" />
          </Box>
        </Box>
        <Box sx={placeDetailTabContainer}>
          <Skeleton variant="rounded" width="350px" height="280px" />
        </Box>
      </Box>
      <Box sx={secondarySection}>
        <Box sx={qrCodeContainer}>
          <Skeleton variant="rounded" width="238px" height="72px" />
        </Box>
        <Box sx={actionContainer}>
          <Skeleton variant="rounded" width="180px" height="56px" />
        </Box>
      </Box>
    </Paper>
  )
}
